<template lang="">
    <div class="flex flex-col md:flex-row justify-between">
        <div>
            <div class="">
                <div class="flex items-center">
                    <h5 class="text text-neutral-content text-lg">
                        <span>ID</span>: {{ " " }}<span class="font-medium text-neutral">{{ id }}</span>
                    </h5>
                    <CopyBoard title="ID" iconName="tabler:copy" classes="ml-2" :text="id" />
                    <CopyBoard :title="$t('orderPage.header.orderLink')" iconName="ci:link" classes="ml-2" :text="orderLink" />
                </div>

                <p class="text-sm text-neutral-content mt-1">
                    {{ moment(created).format("HH:mm DD.MM.YYYY") }}
                </p>
            </div>
        </div>

        <div v-if="time" class="flex flex-col items-end">
            <p class="text-sm text-neutral-content">{{ timeTitleText }}:</p>
            <h5 class="text-xl text-neutral">
                {{ time }}
            </h5>
        </div>
    </div>
</template>
<script>
// Components
import CopyBoard from "../../components/ui/CopyBoard.vue";

// Config
import { URL } from "../../config";

// import { Icon } from "@iconify/vue2";
// Time
import moment from "moment";

export default {
    props: {
        // id: Number,
        // hash: String,
        // created: String,
        // statusPayment: Boolean,
        // statusConfirmReceive: Boolean,
        // cashback: Number,
        order: Object
    },
    data() {
        return {
            now: new Date(),
            timer: ""
        };
    },
    components: {
        CopyBoard
        // Icon
    },
    methods: {
        moment
    },
    created() {
        this.timer = setInterval(() => {
            this.now = new Date();
        }, 1000);
    },
    computed: {
        id() {
            return this.order._id;
        },
        created() {
            return this.order.created;
        },
        statusPayment() {
            return this.order.status == 102 || this.order.status == 101;
        },

        statusConfirmReceive() {
            return this.order.status == 104;
        },
        orderLink() {
            return URL.client + "order/" + this.order.hash;
        },
        time() {
            let order = this.order;
            let status = order.status;
            let isCounterpartyReceive = order.isCounterpartyReceive;
            let expireDate = null;
            if (status == 102 && isCounterpartyReceive) {
                switch (order.CP_STATUS) {
                    case "wait_set_custom_requisite":
                    case "check_payment":
                        expireDate = order.finished;
                        break;
                    case "wait_payment":
                        expireDate = order.CP_EXPIRE_PAYMENT;
                        break;

                    default:
                        throw new Error("Invalid CP_STATUS");
                }
            } else if (this.statusPayment) {
                expireDate = order.finished;
            } else if (this.statusConfirmReceive) {
                expireDate = order.sendExpireDate;
            }

            if (!expireDate) {
                return undefined;
            }
            let diff = new Date(expireDate) - this.now;
            let min = Math.floor(diff / 60000);
            let sec = Math.floor((diff % 60000) / 1000);
            return `${min}:${sec}`;
        },
        timeTitleText() {
            let order = this.order;
            let status = order.status;
            let isCounterpartyReceive = order.isCounterpartyReceive;

            if (status == 102 && isCounterpartyReceive) {
                if (order.CP_STATUS == "wait_set_custom_requisite") {
                    return this.$t("orderPage.header.paymentTimeTitle");
                } else if (order.CP_STATUS == "wait_payment") {
                    return this.$t("orderPage.header.cpPaymentTimeTitle");
                } else if (order.CP_STATUS == "check_payment") {
                    return this.$t("orderPage.header.cpCheckTimeTitle");
                } else {
                    throw new Error("Invalid counterparty status");
                }
            } else if (this.statusPayment) {
                return this.$t("orderPage.header.paymentTimeTitle");
            } else if (this.statusConfirmReceive) {
                return this.$t("orderPage.header.receiveTimeTitle");
            } else {
                return "";
            }
        }
    },
    destroyed() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="scss" scoped>
.orderHeaderSection {
    padding: 24px 32px;
    display: flex;
    justify-content: space-between;
}

.orderHeaderSection .textLine {
    display: flex;
    align-items: center;
}
.orderHeaderSection .orderId {
    font-size: 22px;
    font-weight: 600;
    margin-right: 8px;
}
.orderHeaderSection .orderLink {
    font-size: 14px;
    margin-right: 8px;
    color: #3597fa;
}

.orderLinkSection {
    margin-top: 8px;
}

.orderHeaderSection_timeSection {
    display: flex;
    flex-direction: column;
    // justify-content: space-between;
    align-items: flex-end;
}

.orderHeaderSection_timer {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 10px;
}

.orderHeaderSection_dateCreated {
    font-size: 14px;
}
</style>
